























































































































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
import Bus from "@/JS/Bus";
import replyTabs from "@/components/replyTabs.vue"; // 回复类型列表
@Component({
  components: { replyTabs }
})
export default class extends Vue {
  @Prop() private WxQrCodePosterList!: any;
  @Prop() private page!: any;
  @Provide() momentDataArr: any = [
    {
      sortid: 0,
      isActive: true,
      endRow: 1,
      rowArr: [
        { typeID: 1, data: "" },
        { typeID: 2, data: "" },
        { typeID: 3, data: "" },
        { typeID: 4, data: "" },
        { typeID: 5, data: "" },
        { typeID: 6, data: "" },
        { typeID: 7, data: "" }
      ]
    }
  ];
  @Provide() activeRow: number = 0;
  @Provide() modelTemplateTitle = "新建";
  @Provide() formDialogVisible: boolean = false;
  @Provide() GetQrCodeRowVisible: boolean = false;
  @Provide() ScanCodeRowVisible: boolean = false;
  @Provide() replyDisplay: boolean = false;
  @Provide() loading: boolean = false;
  @Provide() drainageMethod: number = 0;
  @Provide() method: number = 0;
  @Provide() aid: number = 0;
  @Provide() maxDate: any;
  @Provide() minDate: any;
  @Provide() pagesize: number = 10;
  @Provide() currentPage: number = 1;
  @Provide() total: number = 0;
  @Provide() QrCodeUrl: any = "";
  @Provide() NickName: any = "";
  @Provide() TagidData: any = []; //微信粉丝标签列表
  @Provide() optionFansList: any = [];
  @Provide() drainageMethodOptions = [
    { label: "请选择", value: 0 },
    { label: "常规引流", value: 1 },
    { label: "活动引流", value: 2 }
  ];
  @Provide() methodOptions = [
    { label: "请选择", value: 0 },
    { label: "门店", value: 1 },
    { label: "个人", value: 2 }
  ];
  @Provide() aidOptions: any = [];
  @Provide() wxQrCodePosterListModel: any = {};
  @Provide() FormListData: any = [];
  @Provide() Inquire: any = {};
  async created() {
    // if (this.WxQrCodePosterList) {
    //   this.aid = this.WxQrCodePosterList.Aid;
    // }
    this.AccountList();
  }
  data() {
    return {
      pickerOptions: {
        // 当我们选择日期时的回调方法。返回两个日期的最大值和最小值，第一次返回一个值，第二次返回两个值
        onPick: (maxDate: any, minDate: any) => {
          //当我们选择两个值的时候，就认为用户已经选择完毕
          if (maxDate != null && minDate != null) {
            this.maxDate = maxDate;
            this.minDate = minDate;
          }
        },
        disabledDate: (time: any) => {
          //设置当前时间后的时间不可选
          return time.getTime() < Date.now();
        }
      },
      rules: {
        EventName: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        Groups: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        DrainageMethod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        QrCodeType: [{ required: true, message: "请选择", trigger: "change" }],
        eventEndTime: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        Method: [{ required: true, message: "请选择", trigger: "change" }],
        EditPoster: [{ required: true, message: "请选择", trigger: "change" }],
        ScanStatistics: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        Ldentification: [
          { required: true, message: "请选择", trigger: "change" }
        ]
      }
    };
  }
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.wxGetPosterList();
  }
  private handleCurrentChange(val: any) {
    this.currentPage = val;
    this.wxGetPosterList();
  }
  //查询应用信息列表
  async AccountList() {
    let params: any = {
      Input: [
        {
          Name: "Type",
          value: "TypeCode_002,TypeCode_007"
        },
        {
          Name: "Status",
          value: "1"
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.AccountList(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.aidOptions = JSON.parse(res.output[0].value);
      console.log(this.aidOptions);
      this.aidOptions.forEach((element: any) => {
        if (this.aid == 0) this.aid = element.Aid;
        this.GetSarchTagsAsync();
      });
      this.wxGetPosterList();
    } else {
      this.$message.error("读取列表失败：" + res.ErrorMessage);
    }
  }
  formatDrainageMethod(row: any, column: any) {
    switch (row.DrainageMethod) {
      case 1:
        switch (row.Method) {
          case 1:
            return "常规(门店)";
            break;
          case 2:
            return "常规(个人)";
            break;
        }
        break;
      case 2:
        return "活动";
    }
  }
  formatQrCodeType(row: any, column: any) {
    switch (row.QrCodeType) {
      case 1:
        return "永久";
        break;
      case 2:
        return "临时(" + row.EventEndTime.replace("T", " ") + ")";
        break;
    }
  }

  //查看数据
  viewRow(data: any) {
    this.page.pagesize = this.pagesize;
    this.page.currentPage = this.currentPage;
    this.page.aid = this.aid;
    console.log(this.page);
    this.$emit("formData", {
      pagename: "viewForm",
      WxQrCodePosterList: data,
      WxQrCodePosterDetail: {},
      page: this.page
    });
  }
  //编辑海报
  editPosterRow(data: any) {
    // localStorage.removeItem("WxQrCode");
    //localStorage.removeItem("PosterDataId");
    this.page.pagesize = this.pagesize;
    this.page.currentPage = this.currentPage;
    this.page.aid = this.aid;
    //console.log(this.page);
    console.log(data);
    //this.seche(data);
    localStorage.setItem("WxQrCode", data.PosterId);
    localStorage.setItem("PosterDataId", data.PromotePosterListId);

    //let expireDays = 1000 * 60 * 60;
    // setCookie("PosterId", data.PosterId, expireDays);
    // this.$emit("PosterDataId", data.PosterId);
    this.$emit("formData", {
      pagename: "posterSeting",
      WxQrCodePosterList: data,
      WxQrCodePosterDetail: {},
      page: this.page
    });
  }
  async seche(data: any) {
    console.log(data);

    let params: any = {
      Input: [
        {
          Name: "model",
          Value: data
        }
      ]
    };
    var res = await httpApi.GetVerifyData(params);
    console.log(res);
    if (res.ErrorCode == 0) {
      let datares = res.output[0].value;
      // console.log(data);
      //  getCookie("PosterId");
      //let expireDays = 1000 * 60 * 60;
      //console.log(data.PosterId);
      localStorage.setItem("PosterDataId", datares.PosterId);
      //Bus.$emit("PosterDataId", datares.PosterId);
      // setCookie("PosterId", datares.PosterId, expireDays);
    } else {
      this.$message.error("加载修改数据失败：" + res.ErrorMessage);
    }
  }
  //测试弹出框选择人
  async remoteMethod(query: any) {
    if (query) {
      let params: any = {
        Input: [
          {
            Name: "AppFansSelect",
            Value: {
              Aid: this.aid,
              NickName: query,
              OpenID: "",
              Sex: -1
            }
          }
        ]
      };
      this.loading = true;
      this.optionFansList = [];
      var res: any = await httpApi.SarchFansList(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        // this.optionFansList =;
        res.output[0].value.forEach((element: any) => {
          this.optionFansList.push({
            label: element.NickName,
            value: element.OpenID
          });
          //this.temOptionList.push({ label: element.ElementName, value: element.ElementCode })
        });
        this.$forceUpdate();
        //console.log(this.optionFansList);
      } else {
        this.$router.push("/");
        //  this.$message.error("失败：" + res.ErrorMessage);
      }
    }
  }
  //删除
  deleteRow(data: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      data.ActionName = "DELETE";
      let params: any = {
        Input: [
          {
            Name: "model",
            value: data
          }
        ]
      };
      var res: any = await httpApi.SavePosterList(params);
      //console.log(res);
      if (res.ErrorCode == 0) {
        this.$message.success("删除成功!");
        //保存成功后传个刷新方法过去
        this.wxGetPosterList();
      } else {
        this.$message.error("删除失败：" + res.ErrorMessage);
      }
    });
  }
  //启用、禁用
  async UpOrStop(item: any) {
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: item
        },
        {
          Name: "Status",
          Value: item.Status
        }
      ]
    };
    var res: any = await httpApi.SavePosterList(params);
    this.$message.success("操作成功");
    this.wxGetPosterList();
    //console.log(res);
    if (res.ErrorCode == 0) {
    } else {
      // this.$message.error(res.ErrorMessage);
    }
    this.wxGetPosterList();
  }
  //查询数据列表
  async wxGetPosterList() {
    if (this.drainageMethod != 1) this.method = 0;
    this.Inquire.Aid = this.aid;
    let expireDays = 1000 * 60 * 60;
    setCookie("Aid", this.aid, expireDays);
    this.Inquire.DrainageMethod = this.drainageMethod;
    this.Inquire.Method = this.method;
    let params: any = {
      Input: [
        {
          Name: "page",
          value: { page: this.currentPage, rows: this.pagesize }
        },
        {
          Name: "model",
          value: this.Inquire
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.wxGetPosterList(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.FormListData = res.output[0].value;
      this.total = res.output[1].value;
    } else {
      this.$message.error("读取列表失败：" + res.ErrorMessage);
    }
  }
  //获取二维码
  GetQrCodeRow(data: any) {
    this.QrCodeUrl = "";
    this.GetQrCodeRowVisible = true;
    this.wxQrCodePosterListModel = data;
    this.wxQrCodePosterListModel.QrCodeVal = "";
    this.NickName = "";
  }
  //取二维码地址
  async subGetQrCodeRow() {
    if (!this.wxQrCodePosterListModel.QrCodeVal || !this.NickName) {
      this.$message.error("请输入内容！");
    } else {
      this.wxQrCodePosterListModel.NickName = this.NickName;
      let params: any = {
        Input: [
          {
            Name: "model",
            value: this.wxQrCodePosterListModel
          }
        ]
      };
      this.loading = true;
      var res: any = await httpApi.GetQrCodeData(params);
      this.loading = false;
      console.log(res);
      if (res.ErrorCode == 0) {
        this.QrCodeUrl = res.output[0].value;
      } else {
        this.$message.error("生成失败：" + res.ErrorMessage);
      }
    }
  }
  //修改数据
  modfiyRow(data: any) {
    this.formDialogVisible = true;
    this.wxQrCodePosterListModel = data;
    if (this.wxQrCodePosterListModel.Ldentification == 2) {
      this.wxQrCodePosterListModel.Remarks = parseInt(
        this.wxQrCodePosterListModel.Remarks
      );
    }
  }
  //弹出扫码事件
  ScanCodeRow(data: any) {
    this.ScanCodeRowVisible = true;
    this.wxQrCodePosterListModel = data;
    if (this.wxQrCodePosterListModel.Reply) {
      var data = JSON.parse(this.wxQrCodePosterListModel.Reply);
      this.replyDisplay = data.display;
      this.momentDataArr = JSON.parse(data.value);
    }
  }
  async ScanCodeonSubmit() {
    debugger;
    this.wxQrCodePosterListModel.aid = this.aid;
    var resData = {
      display: this.replyDisplay,
      value: JSON.stringify(this.momentDataArr)
    };
    this.wxQrCodePosterListModel.Reply = JSON.stringify(resData);
    let params: any = {
      Input: [
        {
          Name: "model",
          value: this.wxQrCodePosterListModel
        }
      ]
    };
    var res: any = await httpApi.SavePosterList(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功!");
      //保存成功后传个刷新方法过去
      this.wxGetPosterList();
      this.ScanCodeRowVisible = false;
      this.wxQrCodePosterListModel = {};
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }
  //保存数据
  async onSubmit() {
    (this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        if (
          this.wxQrCodePosterListModel.Ldentification != 1 &&
          this.wxQrCodePosterListModel.Remarks == ""
        ) {
          this.$message.error("请选择标签，或输入备注！");
          return;
        }
        if (this.wxQrCodePosterListModel.Ldentification == 1) {
          this.wxQrCodePosterListModel.Remarks = "";
        }
        this.wxQrCodePosterListModel.aid = this.aid;
        let params: any = {
          Input: [
            {
              Name: "model",
              value: this.wxQrCodePosterListModel
            }
          ]
        };
        console.log(params);
        var res: any = await httpApi.SavePosterList(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          this.$message.success("保存成功!");
          //保存成功后传个刷新方法过去
          this.wxGetPosterList();
          this.formDialogVisible = false;
          this.wxQrCodePosterListModel = {};
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
  //增加标签
  addLabel() {
    this.$prompt("请输入标签名称", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消"
    })
      .then((data: any) => {
        console.log(data.value);
        //创建粉丝标签
        this.saveTag(data.value);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      });
  }
  //保存标签
  async saveTag(vaule: string) {
    //console.log(this.AddAccountForm);
    let saveData: any = {
      ActionName: "CREATE",
      ApplicationId: this.aid,
      WxName: vaule
    };
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: saveData
        }
      ]
    };
    console.log(params);
    var res: any = await httpApi.SaveSynchronousTagsAsync(params);
    console.log(res);
    if (res.ErrorCode == 0) {
      this.$message.success("新增标签成功！");
      this.GetSarchTagsAsync();
    } else {
      this.$message.error(res.ErrorMessage);
    }
  }
  //加载标签分组
  async GetSarchTagsAsync() {
    let params: any = {
      Input: [
        {
          Name: "Aid",
          Value: this.aid
        },
        {
          Name: "act",
          Value: "userList"
        }
      ]
    };
    console.log(params);

    var res: any = await httpApi.SarchTags(params);
    if (res.ErrorCode == 0) {
      //console.log(res);

      this.TagidData = res.output[0].value;
      console.log(this.TagidData);
    }
  }
}
